import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import ClaimProfileWrapper from '../Wrapper';
import Button from '../../Button';
import Link from 'next/link';

export type ClaimProfileInitialProps = {
    educator: PublicEducator;
    onStartClaimClick: () => void;
};

export const ClaimProfileInitial: FunctionComponent<ClaimProfileInitialProps> = ({
    educator,
    onStartClaimClick,
}) => {
    return (
        <ClaimProfileWrapper educator={educator}>
            <h3>
                Verify your ownership of this profile to reply to reviews, update info, promote
                courses and more
            </h3>
            <p>
                By continuing, you are agreeing to our <Link href="/terms">Terms Of Service</Link>{' '}
                and <Link href="/privacy">Privacy Policy</Link>
            </p>
            <Button preset="primary" onClick={onStartClaimClick}>
                Verify ownership & claim profile
            </Button>
        </ClaimProfileWrapper>
    );
};

export default ClaimProfileInitial;
